import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Project } from 'TimelogDataTypes';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  constructor(private http: HttpClient) {}

  getProjects(): Observable<Project[]> {
    return this.http.get<Project[]>('/api/Project');
  }

  updateProject(project: Project): Observable<Project> {
    return this.http.put<Project>('/api/Project', project);
  }

  deleteProject(id: number): Observable<Project> {
    return this.http.delete<Project>('/api/Project/' + id);
  }

  getProjectById(id: number): Observable<Project> {
    return this.http.get<Project>('/api/Project/' + id);
  }
}
